import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { useState, useEffect } from 'react';
import { Button } from './Button';
import * as cookies from 'react-cookies';

export interface Props {
  contentPath: string;
  adminDomainUrl: string;
}

export function AdminBanner({ adminDomainUrl, contentPath }: Props) {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (contentPath && !checked) {
      if (cookies.load('IrhjUTUTnB') === 'RAD6YwnIpj') {
        setChecked(true);
      }
    }
  }, [contentPath]);

  return (
    <>
      {checked && contentPath ? (
        <Wrapper maxWidth={null} marginBottom={null} bg={null} border={null}>
          <div>
            <a href={`${adminDomainUrl}${contentPath}`} target="_blank" rel='noindex, nofollow'>
              <EditButton>{__('Editovať')}</EditButton>
            </a>
          </div>
        </Wrapper>
      ) : (
        <></>
      )}
    </>
  );
}

interface WrapperProps {
  bg: string;
  border: string;
  marginBottom: number;
  maxWidth?: number;
  darkerBg: string;
  darkestBg: string;
}

const Wrapper = styled(FlexRowCenterVertical)`
  text-decoration: none;
  margin: 0 auto;
  margin-bottom: ${({ marginBottom }) => rem(marginBottom)};
  width: 100%;
  max-width: ${({ maxWidth }) => (maxWidth ? rem(maxWidth) : 'initial')};
  border-radius: ${rem(2)};
  border: ${({ border }) => border};
  padding: ${rem(12)} ${rem(16)};
  background: ${(props: WrapperProps) => props.bg};
  align-items: flex-start;
`;

const EditButton = styled(Button)`
  min-height: ${rem(30)};
`;
